import gql from "graphql-tag";

const REMOVE_USER = gql`
  mutation removeUser($userId: ID!) {
    removeUser(userId: $userId)
  }
`;

export default REMOVE_USER;
